var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.file.filename ? _c('img', {
    staticClass: "object-contain w-full h-screen rounded-md",
    attrs: {
      "src": '/portfolio/' + _vm.infosPass.id_pass + '/' + _vm.file.filename,
      "alt": ""
    }
  }) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }